module.exports = __webpack_public_path__ + "img/account.91e84ba0.svg";